/**
 *  Switch and description page
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */

import { PopOver, Switch } from '@/src/components/Antd';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { QuestionCircleFilled } from '@ant-design/icons';
import React from 'react';
import css from './css.less';

const SwitchCombination = (props) => {
  const { title, value, onChange, popoverContent, errorText } = props;

  return (
    <div className={css.switchCombination}>
      <div className={css.switchTop}>
        <div>
          <span className={css.title}>{title}</span>
          <PopOver
            overlay={popoverContent}
            overlayClassName={css.popText}
            title={getI18nFromGeneral('general.switchCombination.title')}
            trigger='click'
            placement='rightTop'>
            <QuestionCircleFilled className={css.popIcon} />
          </PopOver>
        </div>
        <Switch checked={value} onChange={onChange}></Switch>
      </div>
      {errorText && <span>{errorText}</span>}
    </div>
  );
};

export default SwitchCombination;
